import useStagedMixedIds, { StagedChanges } from '@app/hooks/useStagedMixedIds';

export interface StagedIds extends StagedChanges {
  stageAdd(id: string): void;
  stageRemove(id: string): void;
}

// A single saved set is the case where no id is indeterminate
export default function useStagedIds(savedIds: string[]): StagedIds {
  const stagedMixedIds = useStagedMixedIds([savedIds]);

  return {
    activeIds: stagedMixedIds.activeIds,
    addedIds: stagedMixedIds.addedIds,
    removedIds: stagedMixedIds.removedIds,
    changedIds: stagedMixedIds.changedIds,
    hasChanges: stagedMixedIds.hasChanges,
    maxChanges: stagedMixedIds.maxChanges,
    exceedsMaxChanges: stagedMixedIds.exceedsMaxChanges,
    stageAdd: (id): void => stagedMixedIds.stage(id, true),
    stageRemove: (id): void => stagedMixedIds.stage(id, false),
    discard: stagedMixedIds.discard,
  };
}
